import {
  Component,
  OnInit,
  OnDestroy,
  Renderer2,
  HostBinding,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '@services/auth/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
  @HostBinding('class') class = 'login-box';

  loginForm: UntypedFormGroup;
  isAuthLoading = false;

  qrUrl = '';
  showQrSetup = false;
  showCodeField = false;
  errorMsg = '';
  codigo2FA = '';

  constructor(
    private renderer: Renderer2,
    private toastr: ToastrService,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    sessionStorage.removeItem('authToken');
    sessionStorage.removeItem('refreshToken');
    this.renderer.addClass(document.querySelector('app-root'), 'login-page');

    this.loginForm = new UntypedFormGroup({
      username: new UntypedFormControl('', Validators.required),
      password: new UntypedFormControl('', Validators.required),
    });
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(document.querySelector('app-root'), 'login-page');
  }

  login(): void {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      this.toastr.warning('Completa todos los campos obligatorios.');
      return;
    }

    const { username, password } = this.loginForm.value;
    if (!username.trim() || !password.trim()) {
      this.toastr.warning('Los campos no pueden estar vacíos.');
      return;
    }

    this.isAuthLoading = true;
    this.errorMsg = '';

    this.authService.login({ username, password }).subscribe({
      next: (response: { status: number; body: any }) => {
        this.isAuthLoading = false;
        if (response.status === 200) {
          this.handleSuccess(response.body);
          this.router.navigate(['/']);
        } else {
          this.errorMsg = 'Respuesta inesperada del servidor.';
          this.toastr.error(this.errorMsg);
        }
        // switch (response.status) {
        //   case 200:
        //     this.handleSuccess(response.body);
        //     break;

        //   case 206: // Requiere activar 2FA
        //     this.qrUrl = response.body.qrUrl;
        //     this.showQrSetup = true;
        //     this.showCodeField = false;
        //     break;

        //   case 202: // Requiere validar 2FA
        //     this.showQrSetup = false;
        //     this.showCodeField = true;
        //     break;
        // }
      },
      error: (err) => {
        this.isAuthLoading = false;

        if (err.status === 401 || err.status === 403) {
          this.errorMsg = 'Usuario o contraseña incorrectos.';
          return;
        }else {
          this.errorMsg = 'Ocurrió un error inesperado.';
        }

        // if (this.parseError(err.error) === '2FA_REQUIRED') {
        //   this.showQrSetup = false;
        //   this.showCodeField = true;
        //   this.errorMsg = '';
        //   return;
        // }

        this.errorMsg = this.parseError(err.error);
      },
    });
  }

  validar2FA(): void {
    const username = this.loginForm.value.username;
    const codigo = parseInt(this.codigo2FA, 10);

    if (!codigo || this.codigo2FA.length !== 6) {
      this.toastr.error('Código inválido. Debe tener 6 dígitos.');
      return;
    }

    this.isAuthLoading = true;
    this.errorMsg = '';

    this.authService.validate2FA(username, codigo).subscribe({
      next: (res) => {
        this.isAuthLoading = false;
        this.authService.iniciarSesion(res);
        this.router.navigate(['/']);
      },
      error: (err) => {
        this.isAuthLoading = false;

        const mensaje = this.parseError(err.error);

        if (
          mensaje.toLowerCase().includes('token') ||
          mensaje.toLowerCase().includes('invalid') ||
          mensaje.toLowerCase().includes('incorrecto') ||
          err.status === 401
        ) {
          this.errorMsg = 'Código inválido o expirado. Intenta nuevamente.';
          this.toastr.error(this.errorMsg);
        } else {
          this.errorMsg = mensaje;
          this.toastr.error(this.errorMsg);
        }
      },
    });
  }

  activar2FA(): void {
    const username = this.loginForm.value.username;
    const codigo = parseInt(this.codigo2FA, 10);

    if (!codigo || this.codigo2FA.length !== 6) {
      this.toastr.error('Código inválido. Debe tener 6 dígitos.');
      return;
    }

    this.isAuthLoading = true;
    this.errorMsg = '';
    this.authService.activate2FA(username, codigo).subscribe({     
      next: (res) => {
        this.isAuthLoading = false;
        this.authService.iniciarSesion(res);
        this.router.navigate(['/']);
      },
      error: (err) => {
        console.log(this.codigo2FA);
        this.isAuthLoading = false;

        const mensaje = this.parseError(err.error);
        if (
          mensaje.toLowerCase().includes('token') ||
          mensaje.toLowerCase().includes('invalid') ||
          mensaje.toLowerCase().includes('incorrecto') ||
          err.status === 401
        ) {
          this.errorMsg = 'Código inválido o expirado. Intenta nuevamente.';
          this.toastr.error(this.errorMsg);
        } else {
          this.errorMsg = mensaje;
          this.toastr.error(this.errorMsg);
        }
      },
    });
  }

  private handleSuccess(res: any): void {
    this.authService.iniciarSesion(res);
    this.router.navigate(['/']);
  }

  private parseError(error: any): string {
    if (typeof error === 'string') return error;
    if (error?.text) return error.text;
    if (error?.message) return error.message;
    if (error?.error && typeof error.error === 'string') return error.error;
    return 'Ocurrió un error inesperado';
  }
}
